.radioContainer {
  display: flex;
  align-items: center;

  .radioLabel {
    position: relative;
    font-size: 22px;
    user-select: none;

    input {
      position: absolute;
      opacity: 0;
      display: none;

      &:checked {
        ~ .checkmark {
          .checkedElement {
            content: "";
            width: 70%;
            height: 70%;
            aspect-ratio: 1/1;
            transition: width 0.25s ease-in, height 0.25s ease-in;
          }
        }
      }
    }

    .checkmark {
      cursor: pointer;
      display: block;
      position: relative;
      border-radius: 50%;
      transition: background-color 0.25s;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20px;
      width: 20px;
      box-sizing: border-box;

      .checkedElement {
        pointer-events: none;
        border-radius: 50%;
        height: 0;
        width: 0;
        transition: width 0.25s ease-out, height 0.25s ease-out;
      }
    }
  }
}
